// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wt_a bii_b"};